
import MDBox from "components/MDBox";
import LocalDataTable from "examples/Tables/LocalDataTable";
import { Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import DefaultCell from "examples/Tables/components/DefaultCell";
import { InfoOutlined } from "@mui/icons-material";
import { getSubscriptionsListingApi } from "lib/Api/Dashboard";
import moment from "moment";
import RemainingDays from "layouts/pages/subscriptions/RemainingDays";
import getExpiryStatus from "utils/getExpiryStatus";


function SubscriptionListing() {

  const [dataTableColumns, setDataTableColumns] = useState([
    {
      Header: "Tenant Name",
      accessor: "first_name",
      sort: true, 
      filterInputType: "text",
      filterLabel: "First Name", // Custom filter label
      Cell: ({ value, row }) => <DefaultCell value={`${row.original.first_name}`} />,
    },
    {
      Header: "Tenant Email",
      accessor: "email",
      sort: true, 
      filterInputType: "text",
      filterLabel: "Email", // Custom filter label
      Cell: ({ value, row }) => <DefaultCell value={`${row.original.email}`} />,
    },
    {
      Header: "Plan",
      accessor: "plan",
      sort: true, 
      filterInputType: "text",
      filterLabel: "Plan", // Custom filter label
      Cell: ({ value, row }) => <DefaultCell value={`${row.original.plan}`} />,
    },
    {
      Header: "Price",
      accessor: "purchase_price",
      sort: true, 
      Cell: ({ value, row }) => (
        <DefaultCell
          value={`$${row.original.purchase_price}/${
            row.original.plan_duration_type === 2 ? "month" : "year"
          }`}
        />
      ),
    },
    {
      Header: "Plan End Date",
      accessor: "end_date",
      sort: true, 
      filterInputType: "date",
      Cell: ({ value, row }) => {
        const expiryStatus = getExpiryStatus(row.original.end_date_original);

          return (
            <DefaultCell
            value={
              expiryStatus.daysRemaining < 7 ? (
                <RemainingDays endDate={value} expiryStatus={expiryStatus} />
              ) : (
                <DefaultCell value={value} />
              )
            }
            />
          );
      },
    },
  ]);

  const [isLoading, setIsLoading] = useState(false);

    // Local data table doesn't need server-side pagination state
  const [tableData, setTableData] = useState({
    columns: dataTableColumns,
    rows: [],
  });

  // Default sorting for local data table
  const [defaultSorting, setDefaultSorting] = useState([{ id: "end_date", asc: true }]);

  const getSubscriptionListingData = async () => {
    try {
      setIsLoading(true);

      // Fetch all data for local data table (no pagination needed)
 

      const response = await getSubscriptionsListingApi();

      if (response && response.status === 200) {
        setTableData({
          ...tableData,
          rows: response.data.data.rows.map((row) => ({
            ...row,
            first_name: row.user.first_name,
            email: row.user.email,
            plan: row.plan.name,
            plan_duration_type: row.plan.plan_duration_type,
            end_date: moment(row.end_date).format("MM/DD/YYYY"),
            end_date_original: row.end_date, // Store original date for getExpiryStatus
          })),
        });
      }
    } catch (error) {
      console.log("error (getSubscriptionListingData): ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setTableData({
      ...tableData,
      columns: dataTableColumns,
    });
  }, [dataTableColumns]);

  useEffect(() => {
    getSubscriptionListingData();
  }, []);

  return (
    <MDBox pt={3} pb={3}>
      <LocalDataTable
        table={tableData}
        isLoading={isLoading}
        isCSVExport={false} 
        defaultSorting={defaultSorting}
        onRefresh={getSubscriptionListingData}
      />
    </MDBox>
  );
}

export default SubscriptionListing;
